import axios from "axios";
import config from "../config";

const serverConfig = { withCredentials: true };

/**
 * Generate (or fetch cached) plan health report.
 * @param {string} planId
 * @returns {Promise<{ report: object, fromCache: boolean }>}
 */
export const getPlanReport = async (planId) => {
  const { data } = await axios.post(
    `${config.apiUrl}/api/v1/ai/plan/${planId}/report`,
    {},
    serverConfig
  );
  return data;
};
